import LightNews from "@/app/assets/icons/light-news";
import { useCleverTapEvents } from "@/app/hooks/use-clevertap";
import { ThirdPartyData } from "@/app/interface/docvault";
// import { initBranch, trackEvent } from "@/app/utils/branchio";
import { ICM_NEWS_LINK } from "@/app/utils/constants";
import { timeAgo } from "@/app/utils/helper";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { ButtonSize, ButtonVariant, RegularButton } from "@/stories/button/button";
import React from "react";

export interface NewsData {
    order: number;
    heading: string;
    description: string;
    publishDate: number;
    webLink: string;
}

interface NewsCardProps {
    newsData: NewsData[];
    productId?:string;
    thirdPartyData?: ThirdPartyData | undefined;
    showViewAll?: boolean
}

const NewsCard: React.FC<NewsCardProps> = ({ newsData,productId, showViewAll = true }) => {
    const { cleverTapTrackEvent } = useCleverTapEvents();
    
    return (
        <div className="mt-4 rounded-2xl border p-5 sm:mt-8 sm:w-[832px] sm:p-6 sm:px-5">
            <div className="sm-pb-4 mb-5 flex items-center justify-between border-b border-dashed border-gray-400 pb-5">
                <h2 className="text-md font-semibold text-gray-900">In the News</h2>
                {showViewAll && <button
                    className="text-sm text-gray-500 hover:underline"
                    onClick={() => {
                        setAnalyticsEvent(
                            "",
                            `US_Listing_page_view_In_the_news_view_all_${productId}`,
                        );
                        cleverTapTrackEvent(`US_Listing_page_view_In_the_news_view_all_${productId}`, {});
                        // initBranch()
                        //     .then(() => {
                        //         trackEvent(
                        //             `US_Listing_page_view_In_the_news_view_all_${productId}`,
                        //             thirdPartyData?.email || "",
                        //             thirdPartyData?.phone || "",
                        //         );
                        //     })
                        //     .catch((error) => console.error("Error initializing Branch:", error));
                        window.location.href = ICM_NEWS_LINK;
                    }}
                >
                    View all
                </button>}
            </div>
            {newsData
                .sort((a, b) => a.order - b.order)
                .slice(0, 3)
                .map((item, index) => {
                    return (
                        <div
                            className={`flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-0 ${index === 0 ? "" : "pt-s9"}`}
                            key={index}
                        >
                            <div className="space-y-2">
                                <h3 className="text-sm font-normal text-gray-500">
                                    {item?.heading}
                                </h3>
                                <p
                                    className="line-clamp-2 text-sm font-medium leading-relaxed text-gray-800"
                                    title={item?.description}
                                >
                                    {item?.description}
                                </p>
                                <p className="text-xs text-black">{timeAgo(item?.publishDate)}</p>
                            </div>

                            <RegularButton
                                variant={ButtonVariant.SecondaryWhite}
                                size={ButtonSize.Medium}
                                icon={<LightNews className="h-5 w-5" />}
                                showRightIcon={false}
                                label={"See insights"}
                                onClick={() => {
                                    setAnalyticsEvent(
                                        "",
                                        `US_Listing_page_view_In_the_news_view_all_${productId}`,
                                    );
                                    cleverTapTrackEvent(`US_Listing_page_view_In_the_news_view_all_${productId}`, {});
                                    // initBranch()
                                    //     .then(() => {
                                    //         trackEvent(
                                    //             `US_Listing_page_view_In_the_news_insights_${productId}`,
                                    //             thirdPartyData?.email || "",
                                    //             thirdPartyData?.phone || "",
                                    //         );
                                    //     })
                                    //     .catch((error) =>
                                    //         console.error("Error initializing Branch:", error),
                                    //     );
                                    window.location.href = item?.webLink;
                                }}
                                className="w-full max-w-full border-2 border-gray-200 text-black md:w-auto"
                            />
                        </div>
                    );
                })}
        </div>
    );
};

export default NewsCard;